import React from "react";

interface Props {
  level?: number | null;
  className?: string;
}

// SVG battery fill constants (based on viewBox "0 0 22 13")
const BATTERY_FILL_X = 2.41238;
const BATTERY_FILL_Y = 2.41238;
const BATTERY_FILL_HEIGHT = 7.23712;
const BATTERY_FILL_MAX_WIDTH = 15.68; // from fill left edge to inner right edge

const SENSOR_BATTERY_LEVEL_TO_PERCENT: Record<number, number> = {
  1: 0,
  2: 25,
  3: 50,
  4: 75,
  5: 100,
};

const normalizeLevel = (level?: number | null) => {
  const parsed = Number(level);

  if (!Number.isFinite(parsed)) {
    return 0;
  }

  return Math.round(parsed);
};

export const DeviceBattery = ({ level, className }: Props) => {
  const normalizedLevel = normalizeLevel(level);
  const displayPercent = SENSOR_BATTERY_LEVEL_TO_PERCENT[normalizedLevel];

  if (displayPercent === undefined) {
    return <span className="DeviceForm__sensorBatteryUnknown">Unknown</span>;
  }

  const batteryFillWidth = (displayPercent / 100) * BATTERY_FILL_MAX_WIDTH;
  const batteryColor = normalizedLevel === 1 ? "#E24A1A" : "#808080";

  return (
    <svg
      className={className}
      width="21"
      height="16"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Battery level"
    >
      <rect
        x={BATTERY_FILL_X}
        y={BATTERY_FILL_Y}
        width={batteryFillWidth}
        height={BATTERY_FILL_HEIGHT}
        rx="0.3"
        fill={batteryColor}
      />
      <path
        d="M20.5052 3.01547C20.8382 3.01547 21.1224 3.13326 21.358 3.36884C21.5936 3.60443 21.7114 3.8887 21.7114 4.22166V7.84022C21.7114 8.17318 21.5936 8.45745 21.358 8.69303C21.1224 8.92862 20.8382 9.04641 20.5052 9.04641V10.5541C20.5052 10.9688 20.3576 11.3237 20.0623 11.619C19.767 11.9142 19.4121 12.0619 18.9975 12.0619H1.50773C1.09311 12.0619 0.738162 11.9142 0.442897 11.619C0.147632 11.3237 0 10.9688 0 10.5541V1.50773C0 1.09311 0.147632 0.738162 0.442897 0.442897C0.738162 0.147632 1.09311 0 1.50773 0H18.9975C19.4121 0 19.767 0.147632 20.0623 0.442897C20.3576 0.738162 20.5052 1.09311 20.5052 1.50773V3.01547ZM20.5052 7.84022V4.22166H19.299V1.50773C19.299 1.41978 19.2707 1.34754 19.2142 1.291C19.1577 1.23446 19.0854 1.20619 18.9975 1.20619H1.50773C1.41978 1.20619 1.34754 1.23446 1.291 1.291C1.23446 1.34754 1.20619 1.41978 1.20619 1.50773V10.5541C1.20619 10.6421 1.23446 10.7143 1.291 10.7709C1.34754 10.8274 1.41978 10.8557 1.50773 10.8557H18.9975C19.0854 10.8557 19.1577 10.8274 19.2142 10.7709C19.2707 10.7143 19.299 10.6421 19.299 10.5541V7.84022H20.5052Z"
        fill={batteryColor}
      />
    </svg>
  );
};
